import { FrontendAddonWithTargetVersionRaw } from "@/domain/FrontendAddon";
import { Tab, TabList } from "@fluentui/react-components";
import React from "react";
import { useSearchParams } from "react-router-dom";
import { FrontendAddonPropertyUpdate } from "./components/FrontendAddonPropertyUpdate";
import { FrontendAddonVersionManagement } from "./components/FrontendAddonVersionManagement";
import styles from "./index.module.css";

const kindList: {
  displayName: string;
  key: string;
}[] = [
  {
    displayName: `設定`,
    key: "info",
  },
  {
    displayName: `バージョン管理`,
    key: "version",
  },
];

export const FrontendAddonFormEdit = <
  T extends FrontendAddonWithTargetVersionRaw,
>({
  returnPath,
  runReloadFrontendAddons,
  targetFrontendAddon,
  renderExtraFields,
  belowCardElement,
  onSave,
  versionUpdatePath,
  showVersionSettings = true,
}: {
  returnPath: string;
  runReloadFrontendAddons: () => Promise<void>;
  targetFrontendAddon: T | undefined;
  renderExtraFields?: (props: { isDisableForm: boolean }) => {
    node: React.ReactNode;
    isDisabledSave?: boolean;
  };
  belowCardElement?: React.ReactNode;
  onSave?: () => Promise<void>;
  versionUpdatePath: string;
  showVersionSettings?: boolean;
}) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const tabParam = searchParams.get("tab");
  const selectedKind =
    kindList.find(({ key }) => key === tabParam) ?? kindList[0];
  const setSelectedKind = (kind: { key: string }) => {
    setSearchParams({ tab: kind.key }, { replace: true });
  };
  const isProd = process.env.APP_ENV === "production";

  return (
    <>
      <TabList
        className={styles.tabList}
        selectedValue={selectedKind.key}
        onTabSelect={(_e, data) => {
          const kind = kindList.find(({ key }) => key === data.value);
          kind && setSelectedKind(kind);
        }}
      >
        {kindList.map(({ displayName, key }) => (
          <Tab key={key} value={key}>
            {displayName}
          </Tab>
        ))}
      </TabList>

      {selectedKind.key === "info" ? (
        <FrontendAddonPropertyUpdate
          {...{
            isProd,
            returnPath,
            runReloadFrontendAddons,
            targetFrontendAddon,
            renderExtraFields,
            belowCardElement,
            onSave,
          }}
        />
      ) : (
        <FrontendAddonVersionManagement
          isProd={isProd}
          targetFrontendAddon={targetFrontendAddon}
          runReloadFrontendAddons={runReloadFrontendAddons}
          versionUpdatePath={versionUpdatePath}
          showVersionSettings={showVersionSettings}
        />
      )}
    </>
  );
};
